import * as p from '@clack/prompts'
import type { DeployProvider } from '@cli-types/next-adapter/init.js'

export async function promptDeployProvider(
  initialValue: DeployProvider = 'none'
): Promise<DeployProvider> {
  const provider = await p.select({
    message: 'Deploy this project',
    options: [
      {
        value: 'vercel' as const,
        label: 'Vercel'
      },
      {
        value: 'railway' as const,
        label: 'Railway'
      },
      {
        value: 'none' as const,
        label: 'Not now'
      }
    ],
    initialValue
  })

  if (p.isCancel(provider)) {
    p.cancel('Setup cancelled.')
    process.exit(0)
  }

  return provider
}
